import React, { useEffect, useRef } from 'react';

const KajabiFormEmbed = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Dynamically load the extra form script
    const script = document.createElement('script');
    script.src = 'https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-9b8c371b37b4392ca2c07507be46cad6d0596c983ec7c5a4120b04134ef6b784.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);

  const formHtml = `
    <link href="//fonts.googleapis.com/css?family=Open+Sans:400,700" rel="stylesheet" type="text/css">
    <link rel="stylesheet" media="all" href="https://kajabi-app-assets.kajabi-cdn.com/assets/form_embed-86c7521dc7acadef8d99e197de2254b9aa81274569ca6ca534de8e1dac7bc3a7.css" />

    <div id="kajabi-form" class="kajabi-form--inline">
      <form data-parsley-validate="true" data-kjb-disable-on-submit="true"
            action="https://www.jtncgroup.com/forms/2149107495/form_submissions"
            accept-charset="UTF-8" method="post">
        <input name="utf8" type="hidden" value="&#x2713;" autocomplete="off" />
        <input type="hidden" name="authenticity_token"
               value="RsqzOv3XuQq1QVAuMz5o/1eYZVd2rcQ3cQiEQs7KHyuFKw0243P9LyTBozAfj6xq0o9ZRmfgDumjBcdRlLrQtQ=="
               autocomplete="off" />
        <style id="form-embed-style" type="text/css">
          #kajabi-form .kajabi-modal__content { background-color: rgba(255, 255, 255, 0); }
          #kajabi-form.kajabi-form--inline { background-color: rgba(255, 255, 255, 0); }
        </style>

        <div class="kajabi-form__content">
          <div class="kajabi-form__title"></div>
          <div class="kajabi-form__subtitle"></div>
          <fieldset>
            <div class="text-field kajabi-form__form-item">
                <input type="text" name="form_submission[name]" id="form_submission_name" value="" required="required" placeholder="Name">
            </div>
            <div class="email-field kajabi-form__form-item">
              <input required="required" placeholder="Email" type="email" name="form_submission[email]" id="form_submission_email" />
            </div>

            <button class="kajabi-form__btn kajabi-form__btn--block-mobile" type="submit">Unlock Free Access</button>
          </fieldset>
        </div>
      </form>
    </div>
  `;

  return <div class="kajabi-form-container" ref={containerRef} dangerouslySetInnerHTML={{ __html: formHtml }} />;
};

export default KajabiFormEmbed;